<template>
    <el-container v-loading="isShowLoading">
        <el-aside style="border-right: 1px solid #eeeeee;">
            <el-container>
                <el-main>
                    <el-tree ref="tree" :data="treeData" :expand-on-click-node="false" :highlight-current="true" :props="defaultProps"
                        accordion lazy :load="getNode" node-key="id" :default-expanded-keys="defaultOpen" v-loading="treeLoading"
                        :render-content="renderContent" @node-click="handleNodeClick"></el-tree>
                </el-main>
            </el-container>
        </el-aside>
        <el-main>
            <el-row>
                <el-form :model="filterData" :inline="true">
                    <el-form-item>
                        <el-input v-model="filterData.czryDm" placeholder="请输入用户代码"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-input v-model="filterData.czryMc" placeholder="请输入用户姓名"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-select v-model="filterData.zhzt" placeholder="--账号状态选择--">
                            <el-option label="--账号状态选择--" value=""></el-option>
                            <el-option label="启用" value="01"></el-option>
                            <el-option label="禁用" value="02"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" size="small" icon="el-icon-search" @click="onFilter">查询</el-button>
                    </el-form-item>
                </el-form>
            </el-row>
            <el-row>
                <el-col :span="24">
                    <el-button type="primary" size="small" icon="el-icon-plus" @click="addUserPage">新增</el-button>
                    <el-button type="primary" size="small" icon="el-icon-document" @click="updateUser">明细</el-button>
                    <el-button type="primary" size="small" icon="el-icon-delete" @click="deleteUser">删除</el-button>
                    <el-button type="primary" size="small" icon="el-icon-check" @click="enableUser('01')"
                        v-bind:disabled="enableBtn.qy">启用</el-button>
                    <el-button type="primary" size="small" icon="el-icon-close" @click="enableUser('02')"
                        v-bind:disabled="enableBtn.jy">禁用</el-button>
                    <el-button type="primary" size="small" icon="el-icon-top" @click="shiftUpUserSequence">上移</el-button>
                    <el-button type="primary" size="small" icon="el-icon-bottom" @click="shiftDownUserSequence">下移</el-button>
                </el-col>
            </el-row>

            <el-table ref="singleTable" :data="recordData" highlight-current-row style="width: 100%" :height="tableHeight" @row-dblclick="onRowDblclick"
              :header-cell-style="{background:'#f5f7fa', color: 'black'}" border :stripe="stripeVisible">
                <el-table-column property="czryDm" label="选择" align="center" width="80">
                    <template slot-scope="scope">
                        <el-radio :label="scope.$index+1" v-model="radio" @change.native="getCurrentRow(scope.row)"></el-radio>
                    </template>
                </el-table-column>
                <el-table-column property="czryDm" label="用户代码" align="center" width="160px" show-overflow-tooltip="true"></el-table-column>
                <el-table-column property="czryMc" label="姓名" align="center" width="150px" show-overflow-tooltip="true"></el-table-column>
                <el-table-column property="zhzt" label="帐号状态" align="center" width="80px">
                    <template slot-scope="scope">
                        <div v-if="scope.row.zhzt == '01'">
                            <i class="el-icon-success" style="color: #67C23A"></i>启用
                        </div>
                        <div v-else-if="scope.row.zhzt == '02'">
                            <i class="el-icon-remove" style="color: #eeeeee"></i>禁用
                        </div>
                    </template></el-table-column>
                <el-table-column property="jgMc" label="所属机构" align="center" width="175px"></el-table-column>
                <el-table-column property="zdhhs" label="最大会话数" align="center" width="95px"></el-table-column>
                <el-table-column property="cjsj" label="创建时间" align="center" width="155px"></el-table-column>
            </el-table>
            <el-row style="margin: 18px 8px">
                <el-col :span="24">
                    <pagination v-show="pagination.total/pagination.pageSize>1" layout="total, sizes, prev, pager, next, jumper"
                        :total="pagination.total" :page.sync="pagination.page" :limit.sync="pagination.pageSize"
                        @pagination="onFilter" />
                </el-col>
            </el-row>

            <div style="height: 60px"></div>
            <el-drawer :visible.sync="layout.edit" :show-close="false" :wrapperClosable="false" :withHeader="false"
                :size="pageWidth + 'px'" direction="rtl" custom-class="demo-drawer" style="top: 67px">
                <div class="demo-drawer-content">
                    <Entity v-if="layout.edit" @back="back" @reload="init" v-bind:entity="entityData" ref="itemPanel"></Entity>
                </div>
            </el-drawer>
        </el-main>
    </el-container>
</template>

<script>
    import Entity from "./Entity.vue";
    import _ from "lodash";

    let _kits, _table;
    export default {
        components: {
            Entity
        },
        data() {
            return {
                radio: "",
                // 树
                defaultOpen: [],
                templateSelection: {},
                defaultProps: {
                    children: "children",
                    label: "name",
                    pid: "pId"
                },
                // loading-tag
                treeLoading: false,
                isShowLoading: true,
                pageWidth: 600,
                //页面布局相关
                layout: {
                    loading: true,
                    width: 600,
                    wd: "80%",
                    edit: false
                },
                //数据绑定相关
                filterData: {
                    jgDm: null
                }, //过滤信息
                enableBtn: { //控制启用禁用
                    qy: false,
                    jy: false
                },
                recordData: [], //展示信息
                pagination: {
                    total: 0,
                    page: 1,
                    pageSize: 10
                }, //分页信息
                treeData: [], // 列表treeData
                entityData: {} //具体某一项信息
            };
        },
        methods: {
            isEmpty(val, defVal) {
                if (_.isEmpty(val)) {
                    return _.isEmpty(defVal) ? true : defVal;
                }
                return val;
            },

            handleNodeClick(data, node, el) {
                console.log(
                    "handleNodeClick",
                    "data:",
                    data,
                    "\n",
                    "node:",
                    node.id,
                    "\n",
                    "vuecomponent",
                    el
                );
                this.filterData.jgDm = data.id;
                //  this.getNode(data);
                this.init();
            },
            onRowDblclick(row, column, event) {
                console.log(row);
            },
            addUserPage() {
                if(this.filterData.jgDm == null){
                    return;
                }
                this.entityData = {
                    jgDm: this.filterData.jgDm
                };
                this.layout.edit = true
            },
            updateUser() {
                if (this.checkSelect()) {
                    return;
                }
                this.entityData = {
                    jgDm: this.filterData.jgDm,
                    czryDm: this.templateSelection.czryDm
                };
                this.layout.edit = true;
            },
            deleteUser() {
                if (this.checkSelect()) {
                    return;
                }
                _kits.confirm({
                    text: "确定删除此用户?",
                    yes: () => {
                        this.layout.loading = true
                        _kits.message("正在删除用户")
                        _kits.api.update(
                            "DELETEUSER", {
                                czryDm: this.templateSelection.czryDm
                            },
                            () => {
                                this.init();
                            }
                        )
                    }
                })
            },
            enableUser(zhzt) {
                if (this.checkSelect()) {
                    return;
                }
                this.layout.loading = true
                _kits.message("正在更新用户状态")
                _kits.api.update(
                    "ENABLEUSER", {
                        czryDm: this.templateSelection.czryDm,
                        zhzt: zhzt
                    },
                    () => {
                        this.init();
                    }
                )


            },
            shiftUpUserSequence() {
                if (this.checkSelect()) {
                    return;
                }
                this.layout.loading = true;
                _kits.message("正在上移");
                _kits.api.update(
                    "SHIFTUPUSERSEQUENCE", {
                        czryDm: this.templateSelection.czryDm
                    },
                    () => {
                        this.init();
                    }
                )
            },
            shiftDownUserSequence() {
                if (this.checkSelect()) {
                    return;
                }
                this.layout.loading = true;
                _kits.message("正在下移");
                _kits.api.update(
                    "SHIFTDOWNUSERSEQUENCE", {
                        czryDm: this.templateSelection.czryDm
                    },
                    () => {
                        this.init();
                    }
                )
            },
            checkSelect() {
                if (this.templateSelection.czryDm == undefined) {
                    this.$alert("请先选择一条记录");
                    return true;
                }
                return false;
            },
            onFilter() {
                this.layout.loading = true;
                _table.load();
            },
            init() {
                this.radio = "";
                _table.load();
            },
            back() {
                this.layout.edit = false;
            },
            getCurrentRow(row) { //获取选中数据
                this.templateSelection = row;
                if (row.zhzt == "01") {
                    this.enableBtn.qy = true;
                    this.enableBtn.jy = false;
                } else {
                    this.enableBtn.qy = false;
                    this.enableBtn.jy = true;
                }
            },
            getNode(node, resolve) {
                let dealedData = [];
                let jkdm = "";
                console.log("getNode", node);
                if (!node.key) {
                    jkdm = "GETTREEROOT";
                } else {
                    jkdm = "GETTREENODE";
                }
                _kits.api.call(
                    jkdm, {
                        jgDm: node.key
                    },
                    result => {
                        console.info("获取组织机构信息getNode");
                        this.treeLoading = false;
                        if (result.returnCode == "0000") {
                            console.log("result.data:", result.data[0]);
                            for (let i = 0; i < result.data.length; i++) {
                                let type = result.data[i].type;
                                if (type == "01") {
                                    result.data[i].icon = "el-icon-house";
                                }
                            }
                            resolve(result.data);
                            let currentKey = this.$refs.tree.getCurrentKey();
                            if (jkdm == "GETTREEROOT") {
                                if (currentKey != result.data[0].id) {
                                    node = this.$refs.tree.getNode(result.data[0].id); // 通过节点id找到对应树节点对象
                                    this.$refs.tree.setCurrentKey(node.key);
                                    this.filterData.jgDm = result.data[0].id;
                                    this.defaultOpen = [result.data[0].id];
                                    this.init();
                                }
                            } else {
                                if (currentKey != node.id) {
                                    this.$refs.tree.setCurrentKey(node.key);
                                }
                            }
                        } else {
                            this.$message.error(result.returnMsg);
                        }
                    }
                );
            }
        },



        created() {
            this.pageWidth = window.innerWidth - 200;
            _kits = this.$kits();
            _table = _kits.table(
                "QUERYUSERFLEX",
                () => {
                    this.isShowLoading = true;
                    return Object.assign({}, this.filterData, this.pagination);
                },
                result => {
                    this.isShowLoading = false;
                    this.isShowLoading = false;
                    this.recordData = result.list;
                    this.pagination.total = Number.parseInt(result.total);
                }
            );
            //this.init();
        },
        computed: {},
        mounted() {

        }
    };
</script>
<style scoped>
</style>
